<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :disabled="disabled"
    :nudge-right="40"
    :return-value.sync="date"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :disabled="disabled"
      :error-messages="error"
      v-model="date"
      :label="label"
      :rules="required ? [rules.required] : []"
      :required="required"
      prepend-icon="mdi-calendar"
      :box="!solo && !std"
      :solo="solo && !std"
      readonly
      clearable
    ></v-text-field>
    <v-date-picker :disabled="disabled" locale="es-es" v-model="date" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn
        v-if="showDeleteButton"
        flat
        color="error"
        @click="
          date = null;
          $refs.menu.save(date);
        "
      >
        {{ $t('Delete') }}
      </v-btn>
      <v-btn v-if="showCancelButton" flat color="primary" @click="menu = false">
        {{ $t('Cancel') }}
      </v-btn>
      <v-btn v-if="showOkButton" flat color="primary" @click="$refs.menu.save(date)">
        {{ $t('OK') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    closeOnContentClick: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showOkButton: {
      type: Boolean,
      default: true,
    },
    std: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: this.value,
      menu: false,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },

  watch: {
    date: function() {
      this.$emit('input', this.date);
      if (this.closeOnContentClick) {
        this.$refs.menu.save(this.date);
      }
    },
    value: function(val) {
      this.date = val;
    },
  },
};
</script>

<style></style>
